import React from "react";
import { Dialog, DialogContent, Box } from "@material-ui/core";
import { getConfigTenant, isCorpTenant } from "@capone/common";
import {
  Icon,
  IconName,
  CorporateTypography,
  CloseButton,
  CorporateButton,
} from "halifax";
import {
  CORP_MARKETPLACE_PACKAGES_NAME,
  CORP_MARKETPLACE_PACKAGES_NAME_VARIANTS,
  TRIP_BUILDER,
  HOTELS_FLIGHTS,
} from "@capone/experiments";
import {
  useExperiments,
  getExperimentVariantCustomVariants,
  CONTROL,
} from "../../../../context/experiments";
import "./styles.scss";

interface IMultiAdultPassengerModalProps {
  open: boolean;
  onClose: () => void;
  onEditTravelers: () => void;
}

export const MultiAdultPassengerModal: React.FC<
  IMultiAdultPassengerModalProps
> = ({ open, onClose, onEditTravelers }) => {
  const isCorporate = isCorpTenant(getConfigTenant());
  const expState = useExperiments();

  if (!isCorporate) {
    return null;
  }

  const corpMarketplacePackagesNameVariant = getExperimentVariantCustomVariants(
    expState.experiments,
    CORP_MARKETPLACE_PACKAGES_NAME,
    CORP_MARKETPLACE_PACKAGES_NAME_VARIANTS
  );

  const getPackagesDisplayName = () => {
    if (!isCorporate) {
      return "packages";
    }

    switch (corpMarketplacePackagesNameVariant) {
      case TRIP_BUILDER:
        return "trip builder";
      case HOTELS_FLIGHTS:
        return "hotels + flights";
      case CONTROL:
      default:
        return "hotels + flights";
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      PaperProps={{
        className: "multi-adult-passenger-modal",
      }}
    >
      <CloseButton onClick={onClose} />
      <DialogContent className="multi-adult-passenger-modal-content">
        <Box>
          <Icon name={IconName.CorpLightbulbModal} />
        </Box>
        <CorporateTypography variant="h2">
          {corpMarketplacePackagesNameVariant === TRIP_BUILDER
            ? "Trip builder"
            : "Hotels + flights"}{" "}
          only supports 1 hotel room per booking
        </CorporateTypography>
        <CorporateTypography variant="body1">
          You can continue with multiple travelers if you plan to share a room.
          If you’d like to book more than 1 room, you can use{" "}
          {getPackagesDisplayName()} for 1 room at a time or book your hotel and
          flight separately.
        </CorporateTypography>
        <Box>
          <CorporateButton
            variant="outlined"
            size="small"
            onClick={onEditTravelers}
          >
            Edit travelers
          </CorporateButton>
          <CorporateButton variant="contained" size="small" onClick={onClose}>
            Continue
          </CorporateButton>
        </Box>
      </DialogContent>
    </Dialog>
  );
};
